<div class="text-600" *ngIf="label || labelIcon">
    <app-icon type="MaterialDesign" [name]="labelIcon" class="align-middle" *ngIf="labelIcon"></app-icon>
    <span>{{label}}</span>
  </div>

  <div class="text-900">
    <p class="m-0" *ngIf="!href"><b class="text-medium">{{value}}</b></p>
    <a class="m-0 btn-link text-primary" *ngIf="href" [href]="href" [target]="target"><b class="text-medium">{{value}}</b></a>
  </div>
  <div class="text-600" *ngIf="hint || hintIcon">
    <app-icon type="MaterialDesign" [name]="hintIcon" class="align-middle" *ngIf="hintIcon"></app-icon>
    {{hint}}
  </div>
